<template>
  <h2 class="alert-dialog-title">
    <slot />
  </h2>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.alert-dialog-title {
  /* Add your styles here */
}
</style>
